<template>
  <div class="reset-password-container">
    <div class="reset-password">
      <div class="header">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <h2>重設密碼</h2>
        <p class="subtitle">請輸入您的新密碼</p>
      </div>

      <form @submit.prevent="resetPassword">
        <div class="form-group">
          <label for="newPassword">新密碼</label>
          <div class="input-wrapper">
            <input
              type="password"
              v-model="newPassword"
              id="newPassword"
              placeholder="請輸入新密碼"
              required
            />
            <span class="input-icon">🔒</span>
          </div>
        </div>

        <div class="form-group">
          <label for="confirmPassword">確認密碼</label>
          <div class="input-wrapper">
            <input
              type="password"
              v-model="confirmPassword"
              id="confirmPassword"
              placeholder="請確認新密碼"
              required
            />
            <span class="input-icon">🔒</span>
          </div>
        </div>

        <div class="password-hint">
          <p>💡 密碼建議:</p>
          <ul>
            <li>至少 8 個字元</li>
            <li>包含大小寫字母與數字</li>
          </ul>
        </div>

        <div class="button-wrapper">
          <button type="submit" class="submit-btn">
            <span>重設密碼</span>
          </button>
        </div>
      </form>

      <div class="footer">
        <router-link to="/login" class="back-link">
          返回登入頁面
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { showError, showSuccess } from "@/assets/js/utils/alertService"; // 引入提示工具
import api from "@/assets/js/utils/api"; // ✅ 引入 axios 客戶端
export default {
  data() {
    return {
      // 初始化空的密碼和確認密碼
      newPassword: "",
      confirmPassword: "",
      // 用於存放從 URL 中獲得的 token
      token: this.$route.query.token || "", // 從路由的 query 參數中取得 token
    };
  },
  methods: {
    async confirmResetPassword() {
      try {
        // 發送重設密碼的請求到後端，帶上員工的 email
        const response = await api.post("/employee/send-reset-password", {
          email: this.selectedEmployee.Email, // 傳送選中員工的 email
        });

        if (response.data.success) {
          showSuccess("重設密碼的郵件已發送成功！");
          this.showResetModal = false; // 關閉 modal
        } else {
          showError(response.data.message || "無法發送重設密碼的郵件");
        }
      } catch (error) {
        showError(
          error.response?.data?.message || "發送重設密碼郵件時發生錯誤"
        );
      }
    },

    async resetPassword() {
      // 驗證密碼與確認密碼是否一致
      if (this.newPassword !== this.confirmPassword) {
        showError("密碼與確認密碼不一致，請重新輸入！");
        return;
      }

      try {
        // 發送重設密碼請求到後端，帶上 token 和新密碼
        const response = await api.post("/employee/reset-password", {
          token: this.token,
          newPassword: this.newPassword,
        });

        if (response.data.success) {
          // 密碼重設成功，顯示成功提示並導向登入頁面
          showSuccess("密碼重設成功！");
          this.$router.push("/login");
        } else {
          // 如果 token 無效或過期，顯示錯誤提示
          showError(response.data.message || "重設密碼失敗");
        }
      } catch (error) {
        // 捕獲異常，顯示錯誤提示
        if (error.response?.data?.message === "無效的 Token 或 Token 已過期") {
          // 如果 Token 過期，告知用戶並防止再次操作
          showError("該連結已過期或無效，請重新請求重設密碼。");
          this.$router.push("/login"); // 可以選擇將用戶引導回登入頁面
        } else {
          showError(
            error.response?.data?.message || "無法處理請求，請稍後再試。"
          );
        }
      }
    },
  },
  // 當組件被創建時，從路由獲取 token
  created() {
    if (!this.token) {
      alert("無效的 Token，請確認您是通過有效的連結進入此頁面。");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
/* Mobile First - 基礎樣式 (手機版) */
.reset-password-container {
  height: 95.7vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #2d3e4f;
  background-attachment: fixed;
}

.reset-password {
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 16px;
  padding: 30px 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: fadeInUp 0.5s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header {
  text-align: center;
  margin-bottom: 32px;
}

.icon-wrapper {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  background: #2d3e4f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

.icon-wrapper svg {
  width: 32px;
  height: 32px;
  color: white;
}

h2 {
  font-size: 26px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.subtitle {
  font-size: 14px;
  color: #718096;
  margin: 0;
  font-weight: 400;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
  letter-spacing: 0.3px;
}

.input-wrapper {
  position: relative;
}

.input-wrapper input {
  width: 100%;
  padding: 14px 16px 14px 44px;
  font-size: 15px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  font-family: inherit;
  background: #f7fafc;
}

.input-wrapper input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
}

.input-wrapper input::placeholder {
  color: #a0aec0;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  opacity: 0.6;
  pointer-events: none;
}

.password-hint {
  background: linear-gradient(135deg, #f0f4ff 0%, #f7fafc 100%);
  border-left: 4px solid #667eea;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 24px;
}

.password-hint p {
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  margin: 0 0 8px 0;
}

.password-hint ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.password-hint li {
  font-size: 12px;
  color: #718096;
  padding: 4px 0;
  padding-left: 20px;
  position: relative;
}

.button-wrapper {
  margin-top: 28px;
}

.submit-btn {
  width: 100%;
  padding: 16px 24px;
  background: #2d3e4f;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  letter-spacing: 0.5px;
}

.submit-btn svg {
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
}

.footer {
  text-align: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.back-link {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 8px 16px;
  border-radius: 8px;
}

/* 平板樣式 (768px 以上) */
@media (min-width: 768px) {
  .reset-password-container {
    padding: 40px;
  }

  .reset-password {
    padding: 40px 36px;
  }

  .icon-wrapper {
    width: 72px;
    height: 72px;
  }

  .icon-wrapper svg {
    width: 36px;
    height: 36px;
  }

  h2 {
    font-size: 30px;
    margin-bottom: 10px;
  }

  .subtitle {
    font-size: 15px;
  }

  .form-group {
    margin-bottom: 24px;
  }

  .form-group label {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .input-wrapper input {
    padding: 16px 18px 16px 48px;
    font-size: 16px;
  }

  .input-icon {
    left: 16px;
    font-size: 20px;
  }

  .password-hint {
    padding: 16px 18px;
  }

  .password-hint p {
    font-size: 14px;
  }

  .password-hint li {
    font-size: 13px;
  }

  .submit-btn {
    padding: 18px 28px;
    font-size: 17px;
  }

  .back-link {
    font-size: 15px;
  }
}

/* 桌面樣式 (1024px 以上) */
@media (min-width: 1024px) {
  .reset-password-container {
    padding: 40px;
    height: 91.5vh;
  }
  
  .reset-password {
    max-width: 480px;
    padding: 50px 48px;
    border-radius: 20px;
  }

  .header {
    margin-bottom: 40px;
  }

  .icon-wrapper {
    width: 80px;
    height: 80px;
    margin-bottom: 24px;
  }

  .icon-wrapper svg {
    width: 40px;
    height: 40px;
  }

  h2 {
    font-size: 34px;
    margin-bottom: 12px;
  }

  .subtitle {
    font-size: 16px;
  }

  .form-group {
    margin-bottom: 28px;
  }

  .form-group label {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .input-wrapper input {
    padding: 18px 20px 18px 52px;
    font-size: 16px;
    border-radius: 12px;
  }

  .input-icon {
    left: 18px;
    font-size: 22px;
  }

  .password-hint {
    padding: 18px 20px;
    margin-bottom: 32px;
  }

  .password-hint p {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .password-hint li {
    font-size: 14px;
    padding: 5px 0;
  }

  .button-wrapper {
    margin-top: 32px;
  }

  .submit-btn {
    padding: 20px 32px;
    font-size: 18px;
    border-radius: 12px;
  }

  .submit-btn svg {
    width: 20px;
    height: 20px;
  }

  .footer {
    margin-top: 28px;
    padding-top: 24px;
  }

  .back-link {
    font-size: 16px;
    padding: 10px 20px;
  }
}
</style>
